const initialState = {
  serverStatus: 'off',
};

export const socketReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SERVER_OFF':
      return { ...state, serverStatus: 'off' };
    case 'SERVER_ON':
      return { ...state, serverStatus: 'on' };
    default:
      return state;
  }
};